import React, { useEffect, useState } from "react";
import ScheduleMeetingPopup from "./ScheduleMeetingPopup";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import {
  addAppSchedule,
  deleteAppSchedule,
  getAppScheduleAddedStatus,
  getAppScheduleDeletedStatus,
  getAppScheduleUpdatedStatus,
  getAppSchedules,
  loadAppSchedules,
  updateAppSchedule,
  getAppScheduleLoading,
  getAppScheduleSaveLoading,
} from "../../app/store/schedule";
import { getCurrentUser } from "../../app/store/auth";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";

const ScheduleMeeting = (props) => {
  const { workflowTask, handleUpdateComponent, partitem } = props;

  const [selectedKey, setSelectedKey] = useState("home");
  const [selectedScheduleId, setSelectedScheduleId] = useState(0);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [updateCompStatus, setUpdateCompStatus] = useState(false);

  const appSchedules = useSelector(getAppSchedules);
  const appScheduleAddedStatus = useSelector(getAppScheduleAddedStatus);
  const appScheduleDeletedStatusSelector = useSelector(getAppScheduleDeletedStatus);
  const appScheduleUpdatedStatusSelector = useSelector(getAppScheduleUpdatedStatus);
  const isLoading = useSelector(getAppScheduleLoading);
  const isSaveLoading = useSelector(getAppScheduleSaveLoading);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  const handleResetSelection = () => {
    setSelectedScheduleId(0);
    setSelectedSchedule(null);
  };

  useEffect(() => {
    if (workflowTask?.ciid) {
      handleResetSelection();
      dispatch(loadAppSchedules(workflowTask.ciid));
      setUpdateCompStatus(true);
    }
  }, [dispatch, workflowTask?.ciid]);

  useEffect(() => {
    if (appSchedules.length > 0) {
      console.log(appSchedules);
      let schItems = "";
      appSchedules.map((x, key) => {
        if (key > 0) schItems += ",";
        schItems += x.meetingId;
        return x;
      });
      if (updateCompStatus) {
        handleUpdateComponent(schItems);
        setUpdateCompStatus(false);
      }
    }
  }, [appSchedules, handleUpdateComponent, updateCompStatus]);

  useEffect(() => {
    if (appScheduleAddedStatus) {
      getAlert("", "Sent Successfully", "success");
      if (workflowTask?.ciid) {
        dispatch(loadAppSchedules(workflowTask.ciid));
        setUpdateCompStatus(true);
      }

      setSelectedScheduleId(0);
      setSelectedSchedule(null);
      setSelectedKey("home");
    }
  }, [appScheduleAddedStatus]);

  useEffect(() => {
    if (appScheduleUpdatedStatusSelector && workflowTask?.ciid) {
      getAlert("", "Updated Successfully", "success");
      dispatch(loadAppSchedules(workflowTask.ciid));
      setSelectedKey("home");
      setSelectedScheduleId(0);
      setSelectedSchedule(null);
    }
  }, [appScheduleUpdatedStatusSelector]);

  useEffect(() => {
    if (appScheduleDeletedStatusSelector && workflowTask?.ciid) {
      getAlert("", "Deleted Successfully", "success");
      if (workflowTask?.ciid) {
        dispatch(loadAppSchedules(workflowTask.ciid));
        setUpdateCompStatus(true);
      }
      setSelectedScheduleId(0);
      setSelectedSchedule(null);
      setSelectedKey("home");
    }
  }, [appScheduleDeletedStatusSelector]);

  const handleSubmit = async (data, scheduleList, meetingJson, meetingProvider) => {
    const frmData = new FormData();
    frmData.append("comment", data["remarks"]);
    frmData.append("meetingJson", meetingJson);
    frmData.append("userId", currentUser.id);
    frmData.append("schedule", JSON.stringify(scheduleList));
    frmData.append("workflowTask", JSON.stringify(workflowTask));
    frmData.append("meetingProvider", meetingProvider);
    dispatch(addAppSchedule(frmData));
  };

  const handleEditAppointment = (item) => {
    dispatch(updateAppSchedule(item));
  };

  const handleDeleteAppointment = async (item) => {
    const result = await getConfirmAlert(
      "Warning",
      "Are you sure, you want to Delete this Schedule Appointment?",
      "warning"
    );
    if (result.isConfirmed) dispatch(deleteAppSchedule(item));
  };

  const handleSelectTab = (tab) => {
    setSelectedKey(tab);
  };

  const handleSelectSchedule = (sch) => {
    if (selectedScheduleId === sch.meetingId) {
      handleResetSelection();
    } else {
      setSelectedSchedule(sch);
      setSelectedScheduleId(sch.meetingId);
    }
  };

  const getCalendarDateParts = (dateStr) => {
    try {
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) {
        return { month: "DATE", day: "Option", weekday: "Option" };
      }
      const month = d.toLocaleString("default", { month: "short" }).toUpperCase();
      const day = d.getDate();
      const weekday = d.toLocaleString("default", { weekday: "short" });
      return { month, day, weekday };
    } catch {
      return { month: "DATE", day: "Option", weekday: "Option" };
    }
  };

  const renderSelectedScheduleCard = (mode = "appointments") => {
    if (selectedScheduleId === 0 || !selectedSchedule) return null;

    const hasAccepted = selectedSchedule.meetingOptions.some((x) => x.status === true);

    return (
      <div className="rt-msg-selected-card">
        <div className="rt-msg-selected-info">
          <div className="rt-msg-selected-avatar">
            {(selectedSchedule.performer || "?").charAt(0).toUpperCase()}
          </div>
          <div className="rt-msg-selected-meta">
            <strong>{selectedSchedule.performer || "Selected Appointment"}</strong>
            <span>
              <i className="fa fa-calendar-check-o" aria-hidden="true" />
              Appointment Request #{selectedScheduleId}
              <span>&bull;</span>
              <span className={`rt-schedule-status-tag ${hasAccepted ? "is-accepted" : "is-pending"}`}>
                {hasAccepted ? "Accepted" : "Pending"}
              </span>
            </span>
          </div>
        </div>
        <div className="rt-msg-selected-actions">
          {mode === "view" ? (
            <button
              className="rt-msg-action-btn"
              onClick={() => handleSelectTab("home")}
              type="button"
            >
              <i className="fa fa-arrow-left" aria-hidden="true" /> Back to Appointments
            </button>
          ) : (
            <button
              className="rt-msg-action-btn is-primary"
              onClick={() => handleSelectTab("appointmentDetails")}
              type="button"
            >
              <i className="fa fa-eye" aria-hidden="true" /> View Details
            </button>
          )}
          {workflowTask.wiid === selectedSchedule.wiid && (
            <>
              <button
                className="rt-msg-action-btn"
                onClick={() => handleSelectTab("profile")}
                type="button"
              >
                <i className="fa fa-pencil" aria-hidden="true" /> Edit
              </button>
              <button
                className="rt-msg-action-btn btn-danger-search"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteAppointment(selectedSchedule);
                }}
                type="button"
                title="Delete Appointment"
              >
                <i className="fa fa-trash-o" aria-hidden="true" /> Delete
              </button>
            </>
          )}
          <button
            className="rt-msg-action-btn btn-danger-search"
            onClick={handleResetSelection}
            type="button"
            title="Clear selection"
            style={{ padding: "8px 12px" }}
          >
            <i className="fa fa-times" aria-hidden="true" />
          </button>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="rt-schedule-workbench">
        <style>{`
          :root {
            --primary-color: #2563eb;
            --primary-hover: #1d4ed8;
            --primary-soft: #eff6ff;
            --secondary-color: #64748b;
            --secondary-hover: #475569;
            --border-color: #e2e8f0;
            --bg-light: #f8fafc;
            --text-main: #1e293b;
            --text-muted: #64748b;
          }

          .rt-schedule-workbench {
            background: transparent !important;
            color: #334155 !important;
            --task-accent: #2563eb !important;
            --task-soft: #eff6ff !important;
            position: relative;
          }

          @keyframes loadingBar {
            0%   { width: 0%; opacity: 1; }
            70%  { width: 85%; opacity: 1; }
            100% { width: 100%; opacity: 0; }
          }

          .wf-loading-bar {
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            height: 3px !important;
            background: linear-gradient(90deg, #2563eb, #7c3aed, #2563eb) !important;
            background-size: 200% 100% !important;
            animation: loadingBar 1.6s ease-in-out infinite !important;
            z-index: 10 !important;
          }

          @keyframes shimmer {
            0%   { background-position: -600px 0; }
            100% { background-position: 600px 0; }
          }

          .skeleton-cell {
            display: block;
            height: 13px;
            border-radius: 6px;
            background: linear-gradient(
              90deg,
              #f1f5f9 25%,
              #e2e8f0 50%,
              #f1f5f9 75%
            );
            background-size: 600px 100%;
            animation: shimmer 1.4s ease-in-out infinite;
          }

          .skeleton-cell.sk-short  { width: 40%; }
          .skeleton-cell.sk-medium { width: 65%; }
          .skeleton-cell.sk-long   { width: 85%; }
          .skeleton-cell.sk-full   { width: 92%; }

          .skeleton-row td {
            padding: 14px 16px !important;
          }

          .rt-msg-tab-bar {
            display: flex;
            align-items: stretch;
            gap: 4px;
            border-bottom: 2px solid #f1f5f9;
            margin-bottom: 0;
            padding: 8px 4px 0;
            position: relative;
          }

          .rt-msg-tab-btn {
            position: relative;
            display: inline-flex;
            align-items: center;
            gap: 7px;
            border: none;
            background: transparent;
            padding: 9px 16px 11px;
            font-size: 13.5px;
            font-weight: 600;
            color: #64748b;
            cursor: pointer;
            border-radius: 8px 8px 0 0;
            transition: color 0.2s ease, background 0.2s ease;
            outline: none;
            white-space: nowrap;
          }
          .rt-msg-tab-btn i {
            font-size: 13px;
            transition: color 0.2s ease;
          }
          .rt-msg-tab-btn:hover {
            color: #1e293b;
            background: rgba(37,99,235,0.04);
          }
          .rt-msg-tab-btn:focus,
          .rt-msg-tab-btn:focus-visible,
          .rt-msg-tab-btn:active {
            outline: none !important;
            box-shadow: none !important;
            border-color: transparent !important;
          }
          .rt-msg-tab-btn.active {
            color: var(--task-accent, #2563eb);
            font-weight: 700;
          }
          .rt-msg-tab-btn.active i {
            color: var(--task-accent, #2563eb);
          }
          .rt-msg-tab-btn::after {
            content: "";
            position: absolute;
            bottom: -2px;
            left: 0;
            right: 0;
            height: 2px;
            background: var(--task-accent, #2563eb);
            border-radius: 2px 2px 0 0;
            transform: scaleX(0);
            transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .rt-msg-tab-btn.active::after {
            transform: scaleX(1);
          }
          .rt-msg-tab-btn.tab-locked .rt-msg-tab-badge {
            background: rgba(245,158,11,0.1);
            color: #b45309;
            border-color: rgba(245,158,11,0.2);
          }
          .rt-msg-tab-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 20px;
            height: 20px;
            padding: 0 6px;
            border-radius: 999px;
            font-size: 11px;
            font-weight: 700;
            background: #f1f5f9;
            color: #64748b;
            border: 1px solid #e2e8f0;
            line-height: 1;
            transition: all 0.2s ease;
          }
          .rt-msg-tab-btn.active .rt-msg-tab-badge {
            background: var(--task-soft, rgba(37,99,235,0.1));
            color: var(--task-accent, #1d4ed8);
            border-color: var(--task-accent, rgba(37,99,235,0.2));
          }

          .rt-msg-panel {
            animation: rtMsgTabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both !important;
            flex: 1 1 auto !important;
            min-height: auto !important;
            overflow-y: visible !important;
            overflow-x: hidden !important;
            padding-top: 4px !important;
            padding-right: 4px !important;
          }
          .rt-msg-panel.is-form-panel,
          .rt-msg-panel.is-reply-panel {
            padding-top: 12px !important;
          }
          @keyframes rtMsgTabFadeIn {
            from { opacity: 0; transform: translateY(6px); }
            to { opacity: 1; transform: translateY(0); }
          }

          .rt-msg-action-btn {
            display: inline-flex !important;
            align-items: center !important;
            gap: 8px !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            padding: 8px 16px !important;
            border-radius: 8px !important;
            font-size: 13px !important;
            font-weight: 600 !important;
            color: #475569 !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            outline: none !important;
            white-space: nowrap !important;
          }
          .rt-msg-action-btn:hover {
            background: #f8fafc !important;
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
          }
          .rt-msg-action-btn.is-primary {
            background: var(--task-accent, #2563eb) !important;
            color: #ffffff !important;
            border-color: var(--task-accent, #2563eb) !important;
          }
          .rt-msg-action-btn.is-primary:hover {
            background: var(--task-accent, #2563eb) !important;
            color: #ffffff !important;
            transform: translateY(-1px) !important;
            opacity: 0.9 !important;
            box-shadow: 0 4px 10px -1px var(--task-accent, rgba(37, 99, 235, 0.25)) !important;
          }
          .rt-msg-action-btn.btn-danger-search {
            background: rgba(239, 68, 68, 0.06) !important;
            color: #dc2626 !important;
            border: 1px solid rgba(239, 68, 68, 0.18) !important;
          }
          .rt-msg-action-btn.btn-danger-search:hover {
            background: rgba(239, 68, 68, 0.12) !important;
            color: #b91c1c !important;
            border-color: rgba(239, 68, 68, 0.28) !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 8px -2px rgba(239, 68, 68, 0.12) !important;
          }

          .rt-msg-selected-card {
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            gap: 20px !important;
            padding: 18px 22px !important;
            margin: 12px 0 !important;
            border: 1px solid rgba(37,99,235,0.12) !important;
            border-radius: 14px !important;
            background: linear-gradient(135deg, rgba(37,99,235,0.04) 0%, rgba(124,58,237,0.03) 100%) !important;
            flex-wrap: wrap !important;
            animation: rtMsgTabFadeIn 0.3s ease both !important;
          }
          .rt-msg-selected-info {
            display: flex !important;
            align-items: center !important;
            gap: 14px !important;
            min-width: 0 !important;
          }
          .rt-msg-selected-avatar {
            width: 46px !important;
            height: 46px !important;
            border-radius: 12px !important;
            background: linear-gradient(135deg, #2563eb, #7c3aed) !important;
            color: #ffffff !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            font-size: 18px !important;
            font-weight: 800 !important;
            flex-shrink: 0 !important;
            box-shadow: 0 4px 10px rgba(37,99,235,0.2) !important;
            border: 2px solid #ffffff !important;
          }
          .rt-msg-selected-meta {
            display: flex !important;
            flex-direction: column !important;
            gap: 4px !important;
            min-width: 0 !important;
          }
          .rt-msg-selected-meta strong {
            display: block !important;
            color: #1e293b !important;
            font-size: 14px !important;
            font-weight: 700 !important;
            margin-bottom: 3px !important;
          }
          .rt-msg-selected-meta span {
            color: #64748b !important;
            font-size: 12px !important;
            font-weight: 500 !important;
            display: flex !important;
            align-items: center !important;
            gap: 7px !important;
            flex-wrap: wrap !important;
          }
          .rt-msg-selected-actions {
            display: flex !important;
            align-items: center !important;
            gap: 8px !important;
            flex-wrap: wrap !important;
            flex-shrink: 0 !important;
          }
          .rt-msg-selected-actions .rt-msg-action-btn {
            height: 38px !important;
            box-sizing: border-box !important;
            justify-content: center !important;
          }
          .rt-msg-selected-actions .btn-danger-search {
            padding: 8px 12px !important;
            min-width: 38px !important;
          }

          .rt-msg-table-scroll {
            overflow: auto !important;
            max-height: 460px !important;
            border-radius: 0.375rem !important;
            position: relative !important;
            scrollbar-width: thin !important;
            scrollbar-color: #94a3b8 #f1f5f9 !important;
          }
          .rt-msg-table {
            width: 100%;
            margin-bottom: 0;
            margin-top: 0px !important;
            border: none;
            border-collapse: separate;
            border-spacing: 0;
            color: var(--text-main, #1e293b);
          }
          .rt-msg-table thead {
            position: sticky;
            top: 0;
            z-index: 2;
            background: var(--bg-light, #f8fafc);
          }
          .rt-msg-table thead th {
            color: var(--text-muted, #64748b);
            font-size: 11.5px;
            font-weight: 700;
            letter-spacing: 0.05em;
            text-transform: uppercase;
            padding: 12px 16px;
            border-top: none;
            border-bottom: 1px solid var(--border-color, #e2e8f0);
            white-space: nowrap;
          }
          .rt-schedule-workbench .rt-msg-table td {
            padding: 14px 16px;
            font-size: 13.5px;
            color: var(--text-main, #1e293b);
            vertical-align: middle;
            border-top: none;
            border-bottom: 1px solid var(--border-color, #e2e8f0);
            background: transparent !important;
            background-color: transparent !important;
            transition: all 0.15s ease;
          }
          .rt-schedule-workbench .rt-msg-table tbody tr:last-child td {
            border-bottom: none;
          }
          .rt-schedule-workbench .rt-msg-table tbody tr.rt-msg-row {
            cursor: pointer;
            transition: transform 0.1s ease !important;
          }
          .rt-schedule-workbench .rt-msg-table tbody tr.rt-msg-row:active {
            transform: scaleY(0.98) !important;
          }
          .rt-schedule-workbench .rt-msg-table tbody tr.rt-msg-row:hover td {
            background-color: rgba(37, 99, 235, 0.04) !important;
            color: #1e293b !important;
          }
          .rt-schedule-workbench .rt-msg-table tbody tr.rt-msg-row:hover td:first-child {
            box-shadow: inset 3px 0 0 0 rgba(37, 99, 235, 0.35) !important;
          }
          .rt-schedule-workbench .rt-msg-table tbody tr.rt-msg-row.selected-row td {
            background-color: rgba(37, 99, 235, 0.07) !important;
            color: #1e3a8a !important;
            font-weight: 500 !important;
            border-bottom: 1px solid rgba(37, 99, 235, 0.08) !important;
          }
          .rt-schedule-workbench .rt-msg-table tbody tr.rt-msg-row.selected-row td:first-child {
            box-shadow: inset 4px 0 0 0 #2563eb !important;
          }
          .rt-schedule-workbench .rt-msg-table tbody tr.rt-msg-row.selected-row:hover td {
            background-color: rgba(37, 99, 235, 0.09) !important;
          }

          .rt-msg-email {
            display: inline-flex;
            align-items: center;
            gap: 5px;
            color: var(--text-muted, #64748b);
            font-size: 13px;
            font-weight: 500;
          }
          .rt-msg-time {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            font-size: 12.5px;
            color: var(--text-muted, #64748b);
            font-weight: 500;
            white-space: nowrap;
          }
          .rt-msg-time-icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            border-radius: 6px;
            background: var(--bg-light, #f8fafc);
            color: var(--text-muted, #64748b);
            font-size: 12px;
          }
          .rt-msg-badge-group {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 6px;
          }
          .rt-msg-badge {
            display: inline-flex;
            align-items: center;
            font-size: 10px;
            font-weight: 700;
            text-transform: uppercase;
            padding: 3px 8px;
            border-radius: 6px;
            letter-spacing: 0.02em;
            border: 1px solid transparent;
          }
          .rt-msg-badge.is-role { background: #f1f5f9; color: #475569; border-color: #e2e8f0; }
          .rt-msg-badge.is-dept { background: #eff6ff; color: #1e40af; border-color: #bfdbfe; }
          .rt-msg-badge.is-partner { background: #fdf2f8; color: #9d174d; border-color: #fbcfe8; }
          .rt-msg-status {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 4px 10px;
            border-radius: 99px;
            font-size: 11.5px;
            font-weight: 600;
            text-transform: uppercase;
            white-space: nowrap;
          }
          .rt-msg-status.is-unread { background: #fef2f2; color: #e11d48; border: 1px solid #fecdd3; }
          .rt-msg-status.is-read { background: #ecfdf5; color: #059669; border: 1px solid #a7f3d0; }
          
          .rt-msg-empty-state {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 220px;
            padding: 36px 20px;
            text-align: center;
            background: #ffffff;
            border-radius: 12px;
          }
          .rt-msg-empty-icon {
            width: 48px;
            height: 48px;
            border-radius: 12px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: var(--primary-soft, #eff6ff);
            color: var(--primary-color, #2563eb);
            font-size: 20px;
            margin-bottom: 16px;
          }
          .rt-msg-empty-title { margin: 0; color: var(--text-main, #1e293b); font-size: 15px; font-weight: 700; }
          .rt-msg-empty-desc { margin: 6px 0 0; color: var(--text-muted, #64748b); font-size: 13px; }

          .wf-name-cell {
            display: flex !important;
            align-items: center !important;
            gap: 10px !important;
            min-width: 190px !important;
          }
          .wf-name-avatar {
            width: 34px !important;
            height: 34px !important;
            border-radius: 10px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            background: linear-gradient(135deg, rgba(37,99,235,0.12), rgba(20,184,166,0.1)) !important;
            border: 1px solid rgba(37,99,235,0.16) !important;
            color: #1d4ed8 !important;
            font-size: 12px !important;
            font-weight: 800 !important;
            flex-shrink: 0 !important;
          }
          .wf-name-meta {
            display: flex !important;
            flex-direction: column !important;
            gap: 2px !important;
            min-width: 0 !important;
          }
          .wf-name-main {
            font-weight: 700 !important;
            color: #1e293b !important;
            font-size: 13.5px !important;
            line-height: 1.2 !important;
          }
          .wf-name-title {
            font-size: 11.5px !important;
            color: #64748b !important;
            font-weight: 500 !important;
            line-height: 1.2 !important;
          }
          .wf-empty-value {
            color: #cbd5e1 !important;
            font-size: 11.5px !important;
            font-weight: 500 !important;
            line-height: 1.2 !important;
          }

          .rt-schedule-slots-title {
            font-size: 11px !important;
            font-weight: 800 !important;
            color: var(--text-muted, #64748b) !important;
            text-transform: uppercase !important;
            letter-spacing: 0.05em !important;
            margin-bottom: 6px !important;
          }
          .rt-schedule-slots-list {
            display: flex !important;
            flex-direction: column !important;
            gap: 4px !important;
            background: #f8fafc !important;
            border: 1px solid #e2e8f0 !important;
            border-radius: 6px !important;
            padding: 8px !important;
          }
          .rt-schedule-slot-item {
            font-size: 13px !important;
            color: #334155 !important;
            display: flex !important;
            align-items: center !important;
            gap: 6px !important;
            font-weight: 500 !important;
          }
          .rt-schedule-slot-item i {
            color: #94a3b8 !important;
          }

          .rt-schedule-accepted-box {
            background: #fffbeb !important;
            border: 1px solid #fde68a !important;
            border-radius: 6px !important;
            padding: 10px 12px !important;
            margin-top: 4px !important;
          }
          .rt-schedule-accepted-header {
            font-size: 10px !important;
            font-weight: 800 !important;
            color: #b45309 !important;
            text-transform: uppercase !important;
            letter-spacing: 0.02em !important;
            display: flex !important;
            align-items: center !important;
            gap: 6px !important;
            margin-bottom: 6px !important;
          }
          .rt-schedule-accepted-datetime {
            font-size: 12px !important;
            font-weight: 700 !important;
            color: #78350f !important;
            display: flex !important;
            align-items: center !important;
            gap: 6px !important;
          }
          .rt-meet-join-btn {
            display: inline-flex !important;
            align-items: center !important;
            gap: 6px !important;
            font-size: 10px !important;
            font-weight: 800 !important;
            color: #ffffff !important;
            background-color: var(--task-accent, #3b82f6) !important;
            border-radius: 6px !important;
            padding: 6px 12px !important;
            text-decoration: none !important;
            transition: all 0.2s ease !important;
            margin-top: 8px !important;
            text-transform: uppercase !important;
            letter-spacing: 0.02em !important;
            border: none !important;
            box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2) !important;
          }
          .rt-meet-join-btn:hover {
            background-color: #2563eb !important;
            color: #ffffff !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 6px rgba(59, 130, 246, 0.3) !important;
          }
          .rt-schedule-remarks {
            font-size: 13px !important;
            color: #475569 !important;
            line-height: 1.4 !important;
            background: #f8fafc !important;
            padding: 8px 12px !important;
            border-radius: 6px !important;
            border-left: 3px solid #cbd5e1 !important;
          }
          .rt-schedule-status-tag {
            font-size: 9px !important;
            font-weight: 800 !important;
            text-transform: uppercase !important;
            padding: 2px 6px !important;
            border-radius: 4px !important;
            letter-spacing: 0.02em !important;
          }
          .rt-schedule-status-tag.is-accepted {
            background: #ecfdf5 !important;
            color: #047857 !important;
            border: 1px solid #a7f3d0 !important;
          }
          .rt-schedule-status-tag.is-pending {
            background: #fffbeb !important;
            color: #b45309 !important;
            border: 1px solid #fde68a !important;
          }
        `}</style>

        <div className="rt-msg-tab-bar">
          <button
            type="button"
            className={`rt-msg-tab-btn${selectedKey === "home" ? " active" : ""}`}
            onClick={() => handleSelectTab("home")}
          >
            <i className="fa fa-calendar" aria-hidden="true" />
            Appointments
            <span className="rt-msg-tab-badge">{appSchedules.length}</span>
          </button>
          <button
            type="button"
            className={`rt-msg-tab-btn${selectedKey === "appointmentDetails" ? " active" : ""}${selectedScheduleId === 0 ? " tab-locked" : ""}`}
            onClick={() => handleSelectTab("appointmentDetails")}
          >
            <i className="fa fa-info-circle" aria-hidden="true" />
            View Details
            {selectedScheduleId > 0 ? (
              <span className="rt-msg-tab-badge">#{selectedScheduleId}</span>
            ) : (
              <span className="rt-msg-tab-badge">
                <i className="fa fa-lock" style={{ fontSize: 9 }} aria-hidden="true" />
              </span>
            )}
          </button>
          <button
            type="button"
            className={`rt-msg-tab-btn${selectedKey === "profile" ? " active" : ""}`}
            onClick={() => handleSelectTab("profile")}
          >
            <i className="fa fa-calendar-plus-o" aria-hidden="true" />
            {selectedScheduleId > 0 ? "Edit" : "Propose"} Appointment
          </button>
        </div>

        {selectedKey === "home" && (
          <div className="rt-msg-panel">
            {renderSelectedScheduleCard()}
            <div className="table-responsive rt-msg-table-scroll">
              <table className="table align-items-center table-flush rt-msg-table">
                <thead>
                  {isLoading && (
                    <tr style={{ height: "0px", padding: 0 }}>
                      <th colSpan={5} style={{ padding: 0, border: "none", height: "0px", position: "relative" }}>
                        <div className="wf-loading-bar" />
                      </th>
                    </tr>
                  )}
                  <tr>
                    <th>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <span>ID</span>
                        {selectedScheduleId > 0 && (
                          <span
                            style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleResetSelection();
                            }}
                            title="Reset Selection"
                          >
                            <i
                              className="fa fa-refresh"
                              style={{ fontSize: "11px", color: "var(--task-accent, #2563eb)" }}
                              aria-hidden="true"
                            />
                          </span>
                        )}
                      </div>
                    </th>
                    <th>Sender Details</th>
                    <th>Meeting Platform(s)</th>
                    <th>Meeting Date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    Array.from({ length: 5 }).map((_, i) => (
                      <tr key={`skel-${i}`} className="skeleton-row">
                        <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                        <td><span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                        <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                        <td><span className="skeleton-cell sk-full" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                        <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.04}s` }} /></td>
                      </tr>
                    ))
                  ) : appSchedules.length === 0 ? (
                    <tr>
                      <td colSpan={5} style={{ padding: 0 }}>
                        <div className="rt-msg-empty-state">
                          <div className="rt-msg-empty-icon">
                            <i className="fa fa-calendar-times-o" aria-hidden="true" />
                          </div>
                          <p className="rt-msg-empty-title">No Appointments Scheduled</p>
                          <p className="rt-msg-empty-desc">
                            Appointment requests proposed to or from the applicant will appear here.
                          </p>
                          <button
                            className="rt-msg-action-btn is-primary"
                            type="button"
                            onClick={() => handleSelectTab("profile")}
                            style={{ marginTop: "12px" }}
                          >
                            <i className="fa fa-calendar-plus-o" aria-hidden="true" /> Propose Appointment
                          </button>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    appSchedules.map((item, idx) => {
                      const isSelected = selectedScheduleId === item.meetingId;
                      const hasAccepted = item.meetingOptions.some((x) => x.status === true);
                      const acceptedOption = item.meetingOptions.find((x) => x.status === true);

                      return (
                        <tr
                          key={item.meetingId}
                          className={`rt-msg-row ${isSelected ? "selected-row" : ""}`}
                          onClick={() => handleSelectSchedule(item)}
                          style={{ animationDelay: `${idx * 0.04}s` }}
                          title={isSelected ? `Click to deselect: Request #${item.meetingId}` : `Click to select: Request #${item.meetingId}`}
                        >
                          <td>
                            <span style={{
                              fontWeight: 600,
                              color: isSelected ? "var(--task-accent, #2563eb)" : "#64748b",
                              fontSize: "12px",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px"
                            }}>
                              {isSelected && (
                                <i className="fa fa-check-circle" style={{ fontSize: "12px", color: "var(--task-accent, #2563eb)" }} />
                              )}
                              #{item.meetingId}
                            </span>
                          </td>
                          <td>
                            <div className="wf-name-cell">
                              <span className="wf-name-avatar">
                                {(item.performer || "?").split(" ").map((n) => n[0]).join("").slice(0, 2).toUpperCase()}
                              </span>
                              <div className="wf-name-meta">
                                <span className="wf-name-main">{item.performer || "System"}</span>
                                {item.role ? (
                                  <span className="wf-name-title">{item.role}</span>
                                ) : item.department ? (
                                  <span className="wf-name-title">{item.department}</span>
                                ) : item.partner ? (
                                  <span className="wf-name-title">{item.partner}</span>
                                ) : (
                                  <span className="wf-empty-value">No title</span>
                                )}
                                {item.email && (
                                  <span className="rt-msg-email" title={item.email} style={{ fontSize: "11px", marginTop: "2px" }}>
                                    <i className="fa fa-envelope-o" aria-hidden="true" /> {item.email}
                                  </span>
                                )}
                              </div>
                            </div>
                          </td>
                          <td>
                            {item.meetingProvider ? (
                              <div className="rt-msg-badge-group">
                                {item.meetingProvider.split(",").map((p, pIdx) => {
                                  const name = p.trim().toLowerCase();
                                  const label = name === "team" ? "MS Teams" : name === "zoom" ? "Zoom" : name === "meet" ? "Google Meet" : p;
                                  const badgeClass = name === "team" ? "is-dept" : name === "zoom" ? "is-role" : name === "meet" ? "is-partner" : "is-role";
                                  return (
                                    <span key={pIdx} className={`rt-msg-badge ${badgeClass}`}>
                                      {label}
                                    </span>
                                  );
                                })}
                              </div>
                            ) : (
                              <span className="rt-msg-id">N/A</span>
                            )}
                          </td>
                          <td>
                            <span className="rt-msg-time">
                              <span className="rt-msg-time-icon">
                                <i className="fa fa-calendar-o" aria-hidden="true" />
                              </span>
                              {hasAccepted && acceptedOption ? (
                                <span>
                                  <strong>Confirmed: </strong>
                                  <Moment format="MMM D, YYYY">{acceptedOption.meetingDate}</Moment>
                                  <span> ({acceptedOption.startTime} - {acceptedOption.endTime})</span>
                                </span>
                              ) : (
                                <span>
                                  <strong>Proposed: </strong>
                                  {item.meetingOptions.length} option(s)
                                </span>
                              )}
                            </span>
                          </td>
                          <td>
                            <span className={`rt-msg-status ${hasAccepted ? "is-read" : "is-unread"}`}>
                              {hasAccepted ? "Accepted" : "Pending"}
                            </span>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {selectedKey === "appointmentDetails" && (
          <div className="rt-msg-panel is-reply-panel">
            {selectedScheduleId === 0 && (
              <div className="rt-msg-empty-state" style={{ border: "1px solid #fda4af", borderRadius: "10px" }}>
                <div className="rt-msg-empty-icon" style={{ background: "#fff1f2", color: "#e11d48" }}>
                  <i className="fa fa-exclamation-circle" aria-hidden="true" />
                </div>
                <p className="rt-msg-empty-title" style={{ color: "#be123c" }}>No Appointment Selected</p>
                <p className="rt-msg-empty-desc" style={{ color: "#e11d48" }}>Select an appointment from the table before viewing its details.</p>
                <button className="rt-msg-action-btn" type="button" onClick={() => handleSelectTab("home")} style={{ marginTop: 12 }}>
                  <i className="fa fa-arrow-left" aria-hidden="true" /> Back to Appointments
                </button>
              </div>
            )}
            {selectedScheduleId > 0 && selectedSchedule && (
              <>
                {renderSelectedScheduleCard("view")}

                <div className="rt-appointment-details-card mt-3">
                  <style>{`
                    .rt-appointment-details-card {
                      background: #ffffff;
                      border: 1px solid var(--border-color, #e2e8f0);
                      border-radius: 16px;
                      padding: 28px;
                      box-shadow: 0 4px 20px -2px rgba(0,0,0,0.02);
                      display: flex;
                      flex-direction: column;
                      gap: 24px;
                    }
                    .details-section-title {
                      font-size: 11.5px;
                      font-weight: 800;
                      color: var(--text-muted, #64748b);
                      text-transform: uppercase;
                      letter-spacing: 0.05em;
                      margin-bottom: 12px;
                      display: flex;
                      align-items: center;
                      gap: 8px;
                    }
                    .details-grid {
                      display: grid;
                      grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
                      gap: 16px;
                    }
                    .details-card {
                      background: #ffffff;
                      border: 1.5px solid #e2e8f0;
                      border-radius: 12px;
                      padding: 12px 18px;
                      display: flex;
                      align-items: center;
                      gap: 14px;
                      transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
                      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.01);
                    }
                    .details-card:hover {
                      border-color: var(--primary-color, #2563eb);
                      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
                      transform: translateY(-1.5px);
                    }
                    .details-card-icon {
                      width: 38px;
                      height: 38px;
                      border-radius: 10px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      font-size: 15px;
                      flex-shrink: 0;
                    }
                    .details-card-icon.icon-user { background: #eff6ff; color: #2563eb; }
                    .details-card-icon.icon-email { background: #f5f3ff; color: #7c3aed; }
                    .details-card-icon.icon-date { background: #ecfdf5; color: #059669; }
                    .details-card-icon.icon-context { background: #fffbeb; color: #d97706; }
                    
                    .details-card-content {
                      display: flex;
                      flex-direction: column;
                      gap: 2px;
                      min-width: 0;
                    }
                    .details-card-label {
                      font-size: 10px;
                      font-weight: 700;
                      text-transform: uppercase;
                      color: #64748b;
                      letter-spacing: 0.03em;
                    }
                    .details-card-value {
                      font-size: 13px;
                      font-weight: 700;
                      color: #0f172a;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }
                    
                    .rt-details-slots-grid {
                      display: grid;
                      grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
                      gap: 12px;
                    }
                    .rt-details-slot-card {
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      padding: 10px 16px;
                      border: 1.5px solid #e2e8f0;
                      border-radius: 12px;
                      background: #ffffff;
                      transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
                      box-shadow: 0 1px 3px rgba(0,0,0,0.01);
                    }
                    .rt-details-slot-card:hover {
                      border-color: var(--primary-color, #2563eb);
                      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
                      transform: translateY(-1.5px);
                    }
                    .rt-details-slot-card.is-accepted {
                      border-color: #22c55e !important;
                      background: #f0fdf4 !important;
                      box-shadow: 0 4px 12px rgba(34, 197, 94, 0.06) !important;
                    }
                    .rt-details-slot-info {
                      display: flex;
                      align-items: center;
                      gap: 14px;
                    }
                    .rt-details-slot-badge-accepted {
                      background: #22c55e;
                      color: #ffffff;
                      font-size: 10px;
                      font-weight: 800;
                      padding: 4px 10px;
                      border-radius: 20px;
                      text-transform: uppercase;
                      letter-spacing: 0.04em;
                      display: inline-flex;
                      align-items: center;
                      gap: 4px;
                      box-shadow: 0 2px 5px rgba(34, 197, 94, 0.2);
                    }
                    
                    .rt-schedule-accepted-banner {
                      background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%) !important;
                      border: 1.5px solid #bbf7d0 !important;
                      border-radius: 12px !important;
                      padding: 20px 24px !important;
                      display: flex !important;
                      align-items: center !important;
                      justify-content: space-between !important;
                      flex-wrap: wrap !important;
                      gap: 16px !important;
                      box-shadow: 0 4px 12px -2px rgba(22, 163, 74, 0.08) !important;
                    }
                    .rt-schedule-accepted-info-shell {
                      display: flex !important;
                      align-items: center !important;
                      gap: 16px !important;
                    }
                    .rt-schedule-accepted-icon-wrap {
                      width: 42px;
                      height: 42px;
                      border-radius: 50%;
                      background: #16a34a;
                      color: #ffffff;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      font-size: 18px;
                      box-shadow: 0 4px 10px rgba(22, 163, 74, 0.2);
                      flex-shrink: 0;
                    }
                    .rt-schedule-accepted-details-wrap {
                      display: flex;
                      flex-direction: column;
                      gap: 3px;
                    }
                    .rt-schedule-accepted-title {
                      font-size: 10.5px;
                      font-weight: 800;
                      text-transform: uppercase;
                      color: #166534;
                      letter-spacing: 0.06em;
                    }
                    .rt-schedule-accepted-time-text {
                      font-size: 15px;
                      font-weight: 800;
                      color: #14532d;
                      display: flex;
                      align-items: center;
                      gap: 8px;
                    }
                    .rt-schedule-accepted-time-text i {
                      font-size: 15px;
                      color: #16a34a;
                    }
                    .rt-schedule-meet-links {
                      display: flex !important;
                      gap: 8px !important;
                      align-items: center !important;
                    }
                    .rt-meet-join-btn {
                      display: inline-flex !important;
                      align-items: center !important;
                      gap: 8px !important;
                      font-size: 11px !important;
                      font-weight: 800 !important;
                      color: #ffffff !important;
                      border-radius: 20px !important;
                      padding: 8px 16px !important;
                      text-decoration: none !important;
                      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
                      border: none !important;
                      text-transform: uppercase !important;
                      letter-spacing: 0.02em !important;
                    }
                    .rt-meet-join-btn.btn-teams {
                      background: #4f46e5 !important;
                      box-shadow: 0 4px 10px rgba(79, 70, 229, 0.15) !important;
                    }
                    .rt-meet-join-btn.btn-teams:hover {
                      background: #4338ca !important;
                      transform: translateY(-1.5px) !important;
                      box-shadow: 0 6px 14px rgba(79, 70, 229, 0.25) !important;
                    }
                    .rt-meet-join-btn.btn-zoom {
                      background: #2563eb !important;
                      box-shadow: 0 4px 10px rgba(37, 99, 235, 0.15) !important;
                    }
                    .rt-meet-join-btn.btn-zoom:hover {
                      background: #1d4ed8 !important;
                      transform: translateY(-1.5px) !important;
                      box-shadow: 0 6px 14px rgba(37, 99, 235, 0.25) !important;
                    }
                    .rt-meet-join-btn.btn-meet {
                      background: #16a34a !important;
                      box-shadow: 0 4px 10px rgba(22, 163, 74, 0.15) !important;
                    }
                    .rt-meet-join-btn.btn-meet:hover {
                      background: #15803d !important;
                      transform: translateY(-1.5px) !important;
                      box-shadow: 0 6px 14px rgba(22, 163, 74, 0.25) !important;
                    }
                    
                    .rt-schedule-remarks-enhanced {
                      font-size: 13.5px !important;
                      color: #334155 !important;
                      line-height: 1.5 !important;
                      background: #f8fafc !important;
                      padding: 16px 20px !important;
                      border-radius: 12px !important;
                      border-left: 4px solid var(--primary-color, #2563eb) !important;
                      display: flex !important;
                      gap: 12px !important;
                      align-items: flex-start !important;
                    }
                    .rt-schedule-remarks-icon {
                      color: #94a3b8;
                      font-size: 16px;
                      margin-top: 2px;
                    }
                  `}</style>

                  <div className="details-grid">
                    <div className="details-card">
                      <div className="details-card-icon icon-user">
                        <i className="fa fa-user" aria-hidden="true" />
                      </div>
                      <div className="details-card-content">
                        <span className="details-card-label">Requested By</span>
                        <span className="details-card-value">{selectedSchedule.performer || "System"}</span>
                      </div>
                    </div>

                    {selectedSchedule.email && (
                      <div className="details-card">
                        <div className="details-card-icon icon-email">
                          <i className="fa fa-envelope" aria-hidden="true" />
                        </div>
                        <div className="details-card-content">
                          <span className="details-card-label">Email Address</span>
                          <span className="details-card-value" title={selectedSchedule.email}>{selectedSchedule.email}</span>
                        </div>
                      </div>
                    )}

                    <div className="details-card">
                      <div className="details-card-icon icon-date">
                        <i className="fa fa-calendar" aria-hidden="true" />
                      </div>
                      <div className="details-card-content">
                        <span className="details-card-label">Requested Date</span>
                        <span className="details-card-value">
                          <Moment format="MMMM D, YYYY, h:mm a">{selectedSchedule.createdDateTime}</Moment>
                        </span>
                      </div>
                    </div>

                    {(selectedSchedule.role || selectedSchedule.department || selectedSchedule.partner) && (
                      <div className="details-card">
                        <div className="details-card-icon icon-context">
                          <i className="fa fa-briefcase" aria-hidden="true" />
                        </div>
                        <div className="details-card-content">
                          <span className="details-card-label">Role / Context</span>
                          <span className="details-card-value" title={[selectedSchedule.role, selectedSchedule.department, selectedSchedule.partner].filter(Boolean).join(" - ")}>
                            {[selectedSchedule.role, selectedSchedule.department, selectedSchedule.partner].filter(Boolean).join(" - ")}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>

                  {selectedSchedule.meetingOptions.some((x) => x.status === true) && (
                    <div className="rt-schedule-accepted-banner">
                      <div className="rt-schedule-accepted-info-shell">
                        <div className="rt-schedule-accepted-icon-wrap">
                          <i className="fa fa-check" />
                        </div>
                        <div className="rt-schedule-accepted-details-wrap">
                          <span className="rt-schedule-accepted-title">Confirmed Meeting Slot</span>
                          <span className="rt-schedule-accepted-time-text">
                            <i className="fa fa-calendar-check-o" />
                            <Moment format="MMMM Do, YYYY">{selectedSchedule.meetingOptions.find((x) => x.status === true).meetingDate}</Moment>
                            <span>&nbsp;({selectedSchedule.meetingOptions.find((x) => x.status === true).startTime} - {selectedSchedule.meetingOptions.find((x) => x.status === true).endTime})</span>
                          </span>
                        </div>
                      </div>
                      {selectedSchedule.meetingLinks && selectedSchedule.meetingProvider && (
                        <div className="rt-schedule-meet-links">
                          {selectedSchedule.meetingProvider.split(",").map((m, idx) => {
                            const link = selectedSchedule.meetingLinks.split(",")[idx];
                            if (!link) return null;
                            const providerTrimmed = m.trim().toLowerCase();
                            const isMeet = providerTrimmed === "meet";
                            const isTeam = providerTrimmed === "team";
                            const isZoom = providerTrimmed === "zoom";
                            const label = isMeet ? "Google Meet" : isTeam ? "MS Teams" : isZoom ? "Zoom" : "Video Call";
                            const icon = isMeet ? "fa-google" : isTeam ? "fa-windows" : isZoom ? "fa-video-camera" : "fa-video-camera";
                            const btnClass = isMeet ? "btn-meet" : isTeam ? "btn-teams" : isZoom ? "btn-zoom" : "btn-zoom";

                            return (
                              <a
                                key={idx}
                                target="_blank"
                                rel="noopener noreferrer"
                                href={link}
                                className={`rt-meet-join-btn ${btnClass}`}
                              >
                                <i className={`fa ${icon}`} aria-hidden="true" /> Join {label}
                              </a>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  )}

                  <div>
                    <div className="details-section-title">
                      <i className="fa fa-calendar-o" aria-hidden="true" />
                      Proposed Options
                    </div>
                    <div className="rt-details-slots-grid">
                      {selectedSchedule.meetingOptions.map((o, idx) => {
                        const { month, day, weekday } = getCalendarDateParts(o.meetingDate);
                        return (
                          <div key={idx} className={`rt-details-slot-card${o.status ? " is-accepted" : ""}`}>
                            <div className="rt-details-slot-info">
                              <div className="slot-calendar-badge" style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "48px",
                                height: "50px",
                                background: "#ffffff",
                                border: o.status ? "1.5px solid #22c55e" : "1.5px solid #e2e8f0",
                                borderRadius: "10px",
                                overflow: "hidden",
                                flexShrink: 0
                              }}>
                                <span className="cal-month" style={{
                                  display: "block",
                                  width: "100%",
                                  background: o.status ? "#22c55e" : "var(--primary-color, #2563eb)",
                                  color: "#ffffff",
                                  fontSize: "9px",
                                  fontWeight: "800",
                                  textAlign: "center",
                                  padding: "2px 0",
                                  letterSpacing: "0.06em"
                                }}>{month}</span>
                                <span className="cal-day" style={{
                                  display: "block",
                                  fontSize: "15px",
                                  fontWeight: "850",
                                  color: "#0f172a",
                                  textAlign: "center",
                                  lineHeight: "1.3"
                                }}>{day}</span>
                              </div>
                              <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                <span style={{ fontSize: "10px", fontWeight: "750", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.04em" }}>{weekday}</span>
                                <span style={{ fontSize: "13px", fontWeight: "750", color: "#0f172a" }}>
                                  <i className="fa fa-clock-o" style={{ color: o.status ? "#22c55e" : "var(--primary-color, #2563eb)", marginRight: "4px" }} />
                                  {o.startTime} - {o.endTime}
                                </span>
                              </div>
                            </div>
                            {o.status && (
                              <span className="rt-details-slot-badge-accepted">
                                <i className="fa fa-check-circle-o" /> Confirmed
                              </span>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {selectedSchedule.remarks && (
                    <div>
                      <div className="details-section-title">
                        <i className="fa fa-commenting-o" aria-hidden="true" />
                        Notes / Remarks
                      </div>
                      <div className="rt-schedule-remarks-enhanced">
                        <i className="fa fa-quote-left rt-schedule-remarks-icon" />
                        <span style={{ whiteSpace: "pre-line" }}>{selectedSchedule.remarks}</span>
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        )}

        {selectedKey === "profile" && (
          <div className="rt-msg-panel is-form-panel">
            <ScheduleMeetingPopup
              partitem={partitem}
              handleSubmit={handleSubmit}
              selectedItem={selectedSchedule}
              handleEditAppointment={handleEditAppointment}
              onClose={() => handleSelectTab("home")}
              isLoading={isSaveLoading}
            />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default ScheduleMeeting;
